import axios from 'axios';

const ODX_ADMIN_BASE_URL = process.env.REACT_APP_ODX_ADMIN_BASE_URL;
const ACCESS_TOKEN = process.env.REACT_APP_ODX_ADMIN_TOKEN;

const odkAdminApiService = {
  // /admin/api/content_providers/?ordering=code&service_name=odc
  fetchCpFromOdc: async (): Promise<any[]> => {
    try {
      const response = await axios.get(
        `${ODX_ADMIN_BASE_URL}/admin/api/content_providers/?ordering=code&service_name=odc`,
        {
          headers: {
            'Authorization': `Token ${ACCESS_TOKEN}`,
            'Content-Type': 'application/json',
            'Service-Name': 'odc'
          }
        }
      );
      return response.data.results.map((item: any) => ({
        key: item.code,
        label: item.name,
        value: item.code,
      }));
    } catch (e) {
      console.warn('fetchCpFromOdc failed (ODX Admin unavailable)');
      return [];
    }
  },

  fetchCpFromOdk: async (): Promise<any[]> => {
    try {
      const response = await axios.get(
        `${ODX_ADMIN_BASE_URL}/admin/api/legacy/programs_cp_list/?service_name=odk`,
        {
          headers: {
            'Authorization': `Token ${ACCESS_TOKEN}`,
            'Content-Type': 'application/json',
            'Service-Name': 'odk'
          }
        }
      );
      return response.data.cp_list.map((item: any) => ({
        key: item,
        label: item,
        value: item,
      })).sort((a: any, b: any) => a.label.localeCompare(b.label));
    } catch (e) {
      console.warn('fetchCpFromOdk failed (ODX Admin unavailable)');
      return [];
    }
  },

  // ODC 검색 API (검색할 때마다 호출)
  searchCpFromOdc: async (searchTerm: string = ''): Promise<any[]> => {
    try {
      const url = searchTerm.trim()
        ? `${ODX_ADMIN_BASE_URL}/admin/api/content_providers/?search=${encodeURIComponent(searchTerm)}&ordering=code&service_name=odc`
        : `${ODX_ADMIN_BASE_URL}/admin/api/content_providers/?ordering=code&service_name=odc`;

      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${ACCESS_TOKEN}`,
          'Content-Type': 'application/json',
          'Service-Name': 'odc'
        }
      });
      return response.data.results.map((item: any) => ({
        key: item.code,
        label: item.name,
        value: item.code,
      }));
    } catch (e) {
      console.warn('searchCpFromOdc failed (ODX Admin unavailable)');
      return [];
    }
  },
};

export default odkAdminApiService;
